import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './table.styl'

export default class TableHeader extends Component {
  static propTypes = {
    ths: PropTypes.array.isRequired,
    sort: PropTypes.string,
    onSortChange: PropTypes.func
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSortChange = sortableId => {
    const { sort, onSortChange } = this.props
    let sortIds = sort.split(',')
    const currId = sortIds.filter(id => id.includes(sortableId)).join()

    if (!currId) {
      sortIds = sortIds.concat(`-${sortableId}`)
    } else if (currId.includes('-')) {
      sortIds = sortIds
        .filter(item => item !== `-${sortableId}`)
        .concat(`+${sortableId}`)
    } else if (currId.includes('+')) {
      sortIds = sortIds
        .filter(item => item !== `+${sortableId}`)
        .concat(`-${sortableId}`)
    }

    onSortChange(sortIds.filter(item => Boolean(item)).reverse().join(','))
  }

  render() {
    const { ths, sort } = this.props

    return (
      <thead>
        <tr>
          {ths.map(th => {
            const isActive =
              sort &&
              sort
                .split(',')
                .filter(item => item.includes(th.sortableId))
                .join()
            const suffix = isActive && isActive.includes('-') ? 'down' : 'up'

            return (
              <th key={th.id}>
                {th.intlKey
                  ? <FormattedMessage
                      id={th.intlKey}
                      defaultMessage={th.label}
                    />
                  : th.label}{' '}
                {th.sortable &&
                  <button
                    className={styles.btnSort}
                    onClick={() => this.handleSortChange(th.sortableId)}
                  >
                    <span className={`ico ico--arrow-${suffix}`} />
                  </button>}
              </th>
            )
          })}
        </tr>
      </thead>
    )
  }
}
